export async function getMailToken(instance, accounts, loginScopes) {
  const mailScopes = [...loginScopes, "Mail.Send"];
  try {
    return await instance.acquireTokenSilent({ scopes: mailScopes, account: accounts[0] });
  } catch {
    return await instance.acquireTokenPopup({ scopes: mailScopes, account: accounts[0] });
  }
}
